<script setup lang="ts">
import type { PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
const { sale } = defineProps({
    sale: { type: Object as PropType<PlatformSaleItemEntity>, required: true },
});

// COMPOSABLES
const { tt } = useTypedI18n();
const { title, busClass } = useSaleTitle(() => sale);
</script>

<template>
    <section class="flex flex-col gap-y-2">
        <p v-if="busClass" class="text-xs md:text-lg">
            {{ busClass }}
        </p>

        <div class="flex flex-wrap items-center gap-x-2">
            <h1 class="text-highlighted text-2xl font-bold md:text-4xl">
                {{ title }}
            </h1>
            <div class="flex flex-row gap-x-2">
                <SdpShareButton :sale="sale" />
                <SaleFavoritesButton :sale="sale" />
            </div>
        </div>

        <p class="text-xs md:text-sm">
            {{ tt('common.incrementIdLabel') }}: <span class="select-all">{{ sale.incrementId }}</span>
        </p>
    </section>
</template>
